"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutFacade = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var section_1 = require("./section");
var sections_1 = require("./sections");
/**
 * @alpha
 */
var DashboardLayoutFacade = /** @class */ (function () {
    function DashboardLayoutFacade(layout) {
        this.layout = layout;
    }
    /**
     * Creates an instance of DashboardLayoutFacade
     * @param layout - layout to wrap
     */
    DashboardLayoutFacade.for = function (layout) {
        ts_invariant_1.default(sdk_backend_spi_1.isDashboardLayout(layout), "Provided data must be IDashboardLayout!");
        return new DashboardLayoutFacade(layout);
    };
    DashboardLayoutFacade.prototype.sections = function () {
        return sections_1.DashboardLayoutSectionsFacade.for(this, this.layout.sections);
    };
    DashboardLayoutFacade.prototype.section = function (rowIndex) {
        var row = this.layout.sections[rowIndex];
        if (!row) {
            return undefined;
        }
        return section_1.DashboardLayoutSectionFacade.for(this, row, rowIndex);
    };
    DashboardLayoutFacade.prototype.size = function () {
        return this.layout.size;
    };
    DashboardLayoutFacade.prototype.raw = function () {
        return this.layout;
    };
    return DashboardLayoutFacade;
}());
exports.DashboardLayoutFacade = DashboardLayoutFacade;
//# sourceMappingURL=layout.js.map